export default "__VITE_ASSET__BxTl$SDJ__"